const modalTitle = 'Como funciona o nivelamento?'
const modalDescription = isCEFR =>
  isCEFR
    ? 'Os livros em inglês foram organizados em níveis, que vão de A1 a C2.'
    : 'Os livros em inglês foram organizados em níveis, que vão de A a Z.'
const modalSubDescription = 'Abaixo temos a explicação de como foram separados:'

// Fountas and Pinnell copy texts
const firstFountasAndPinnelltokensTitle = 'A-D'
const firstFountasAndPinnelltokensSubtitle = 'Níveis A, B, C e D'
const firstFountasAndPinnelltokensDescription =
  'Indicados para leitores iniciantes, com textos simples para o aprendizado das primeiras palavras.'

const secondFountasAndPinnelltokensTitle = 'E-M'
const secondFountasAndPinnelltokensSubtitle =
  'Níveis E, F, G, H, I, J, K, L e M'
const secondFountasAndPinnelltokensDescription =
  'Para leitores iniciados, textos com frases curtas e vocabulário simples.'

const thirdFountasAndPinnelltokensTitle = 'N-S'
const thirdFountasAndPinnelltokensSubtitle = 'Níveis N, O, P, Q, R e S'
const thirdFountasAndPinnelltokensDescription =
  'Para leitores autônomos, que já conseguem ler e compreender textos mais elaborados.'

const fourthFountasAndPinnelltokensTitle = 'T-Z'
const fourthFountasAndPinnelltokensSubtitle = 'Níveis T, U, V, W, X, Y e Z'
const fourthFountasAndPinnelltokensDescription =
  'Para leitores experientes, que conseguem ler e compreender textos mais complexos e extensos.'

const FOUNTAS_AND_PINNELL_DESCRIPTION = [
  {
    title: firstFountasAndPinnelltokensTitle,
    subtitle: firstFountasAndPinnelltokensSubtitle,
    description: firstFountasAndPinnelltokensDescription
  },
  {
    title: secondFountasAndPinnelltokensTitle,
    subtitle: secondFountasAndPinnelltokensSubtitle,
    description: secondFountasAndPinnelltokensDescription
  },
  {
    title: thirdFountasAndPinnelltokensTitle,
    subtitle: thirdFountasAndPinnelltokensSubtitle,
    description: thirdFountasAndPinnelltokensDescription
  },
  {
    title: fourthFountasAndPinnelltokensTitle,
    subtitle: fourthFountasAndPinnelltokensSubtitle,
    description: fourthFountasAndPinnelltokensDescription
  }
]

// CEFR copy text
const a1CefrLevelTitle = 'A1'
const a1CeftLevelSubtitle = 'A1 - Iniciante'
const a1CeftLevelDescription =
  'Indicado para leitores capazes de compreender expressões comuns do dia-a-dia e frases básicas.'

const a2CefrLevelTitle = 'A2'
const a2CeftLevelSubtitle = 'A2 - Básico'
const a2CeftLevelDescription =
  'Indicado para leitores capazes de compreender frases e expressões frequentes relacionadas às áreas de importância primária (informações básicas pessoal, familiar ou relacionada ao trabalho).'

const b1CefrLevelTitle = 'B1'
const b1CeftLevelSubtitle = 'B1 - Intermediário'
const b1CeftLevelDescription =
  'Para leitores capazes de compreender as questões principais, quando é usada uma linguagem clara e padronizadas, sobre assuntos que lhe são familiares ou de interesse pessoal.'

const b2CefrLevelTitle = 'B2'
const b2CeftLevelSubtitle = 'B2 - Independente'
const b2CeftLevelDescription =
  'Para leitores capazes de compreender as ideias principais em textos complexos sobre assuntos concretos e abstrato.'

const c1CefrLevelTitle = 'C1'
const c1CeftLevelSubtitle = 'C1 - Proficiência eficaz'
const c1CeftLevelDescription =
  'Para leitores capazes de compreender um vasto número de textos longos e exigentes, reconhecendo os seus significados implícitos.'

const c2CefrLevelTitle = 'C2'
const c2CeftLevelSubtitle = 'C2 - Domínio Pleno'
const c2CeftLevelDescription =
  'Para leitores capazes de compreender, sem esforço, praticamente tudo o que leem.'

const CEFR_DESCRIPTION = [
  {
    title: a1CefrLevelTitle,
    subtitle: a1CeftLevelSubtitle,
    description: a1CeftLevelDescription
  },
  {
    title: a2CefrLevelTitle,
    subtitle: a2CeftLevelSubtitle,
    description: a2CeftLevelDescription
  },
  {
    title: b1CefrLevelTitle,
    subtitle: b1CeftLevelSubtitle,
    description: b1CeftLevelDescription
  },
  {
    title: b2CefrLevelTitle,
    subtitle: b2CeftLevelSubtitle,
    description: b2CeftLevelDescription
  },
  {
    title: c1CefrLevelTitle,
    subtitle: c1CeftLevelSubtitle,
    description: c1CeftLevelDescription
  },
  {
    title: c2CefrLevelTitle,
    subtitle: c2CeftLevelSubtitle,
    description: c2CeftLevelDescription
  }
]

export {
  modalTitle,
  modalDescription,
  modalSubDescription,
  FOUNTAS_AND_PINNELL_DESCRIPTION,
  CEFR_DESCRIPTION
}
